
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class VinModelComponent extends Vue {
  visible = false;

  @Prop()
  modalList!: any;

  value = '';

  checkedVin: any = {};

  handleOk() {
    this.visible = false;
    this.$emit('checkedVin', this.checkedVin);
    this.checkedVin = {};
    this.value = '';
  }

  handleCancel() {
    this.visible = false;
    this.checkedVin = {};
    this.value = '';
  }

  init() {
    this.visible = true;
  }

  onChange(e: any) {
    console.log('radio checked', e.target.value);
    this.value = e.target.value;
    const checkedVin = this.modalList.find(
      (item: any) => item.id === e.target.value,
    );
    const {
      brand,
      brand_id,
      gear_name,
      id,
      liter,
      model_name,
      official_price,
      series,
      series_id,
    } = checkedVin;
    const formDate = {
      brand,
      brandId: brand_id,
      gearName: gear_name,
      liter,
      modelName: model_name,
      modelId: id,
      official_price: Number(official_price) / 10000,
      series,
      seriesId: series_id,
    };
    this.checkedVin = formDate;
  }
}
